<template>
    <AppFormValidator
        ref="validator"
        #default="{ errors }"
        :model="model"
        :rules="rules">
        <CForm @submit.prevent>
            <CRow form class="form-group">
                <CCol
                    tag="label"
                    class="col-form-label"
                    sm="3">
                    Включено
                </CCol>
                <CCol sm="9">
                    <CSwitch
                        class=""
                        color="success"
                        shape="pill"
                        variant="opposite"
                        :checked.sync="model.enabled" />
                </CCol>
            </CRow>

            <div class="form-row">
                <CCol
                    tag="label"
                    sm="3"
                    class="col-form-label">Место показа</CCol>
                <CCol sm="9" class="col-form-label">
                    <CSelect
                        inline
                        :value.sync="model.route_name"
                        :options="routeNames"
                        placeholder="Страница"
                        @change="updateRouteName" />
                </CCol>
            </div>

            <CInput
                v-model="model.place"
                horizontal
                label="Позиция показа"
                placeholder="Введите позицию показа" />

            <CInput
                horizontal
                :value="model.code"
                label="Код AppsFlyer"
                placeholder="Код для регистрации событий в AppsFlyer"
                @change="updateCode" />

            <CInput
                v-model="model.title"
                horizontal
                label="Название"
                placeholder="Введите название"
                :is-valid="errors.title && errors.title.isValid" />

            <CRow>
                <CCol tag="label" class="col-form-label">{{ routeNamesMap[model.route_name] }}</CCol>
            </CRow>
            <Draggable v-model="entitiesList" tag="div">
                <CRow v-for="item in entitiesList" :key="item.id">
                    <!-- <CCol
                        tag="label"
                        sm="1"
                        class="col-form-label">
                        <CIcon
                            :height="16"
                            :content="cilCursorMove"
                            class="handle" />
                    </CCol> -->
                    <CCol
                        tag="label"
                        sm="4"
                        class="col-form-label">
                        {{ item.title }}
                    </CCol>
                    <CCol sm="1">
                        <CSwitch
                            color="dark"
                            shape="pill"
                            variant="opposite"
                            :checked.sync="list[item.id]" />
                    </CCol>
                </CRow>
            </Draggable>

            <div class="flex mt-4">
                <CButton color="primary" @click="submit">{{ submitButtonTitle }}
                </CButton>
                <CButton
                    v-if="model.id"
                    variant="outline"
                    color="danger"
                    class="ml-4"
                    @click="promptDelete">Удалить
                </CButton>
            </div>
        </CForm>

        <AppConfirmDialog
            ref="confirmDialog"
            title="Подтверждение"
            color="danger"
            text="Вы действительно хотите удалить запись? Это действие нельзя будет отменить."
            @confirm="confirmDelete" />
    </AppFormValidator>
</template>

<script>
    import Vue from 'vue';
    import to from 'await-to-js';
    import { morphism } from 'morphism';
    import { requiredRule } from '@/utils/rules';
    import { translit } from '@/utils/translit';
    import AppFormValidator from '@/components/AppFormValidator';
    import AppConfirmDialog from '@/components/AppConfirmDialog';
    import Draggable from 'vuedraggable';
    import { cilCursorMove } from '@coreui/icons';

    export default {
        components: {
            AppFormValidator,
            AppConfirmDialog,
            Draggable
        },

        props: {
            entity: {
                type: Object,
                default: () => ({}),
            },
        },

        data() {
            return {
                isAuthorized: false,
                cilCursorMove,
                model: {},
                schema: {
                    id: 'id',
                    code: 'code',
                    title: 'title',
                    place: 'place',
                    route_name: 'route_name',
                    list: 'list',
                    enabled: source => Boolean(source.enabled),
                },
                rules: {
                    route_name: [requiredRule],
                    title: [requiredRule],
                    enabled: [requiredRule],
                },
                routeNames: [
                    {
                        label: 'Список ресторанов',
                        value: 'restaurant-list',
                        listVar: 'restaurants',
                    },
                    {
                        label: 'Список продуктовых магазинов',
                        value: 'grocery-list',
                        listVar: 'grocers',
                    },
                    {
                        label: 'Список аптек',
                        value: 'pharmacy-list',
                        listVar: 'pharmacies',
                    },
                ],
                routeNamesMap: {
                    'restaurant-list': 'Список ресторанов',
                    'grocery-list': 'Список продуктовых магазинов',
                    'pharmacy-list': 'Список аптек',
                },
                list: [],
                business: {
                    restaurants: [],
                    grocers: [],
                    pharmacies: [],
                    assistants: [],
                },
                entitiesCopy: [],
                entitiesOrder: [],
                routeName: '',
                entities: {},
            };
        },

        computed: {
            submitButtonTitle() {
                return typeof this.entity.id === 'number' ? 'Сохранить' : 'Создать';
            },
            entitiesList: {
                get() {
                    return this.entitiesCopy;
                },

                set(v) {
                    this.entitiesCopy = v;
                }
            }
        },

        watch: {
            async routeName() {
                for (let i = 0; i < this.routeNames.length; i++) {
                    if (this.routeNames[i].value === this.routeName) {
                        this.entities = this.business[this.routeNames[i].listVar] || [];
                        this.entitiesCopy = this.entities;
                    }
                }
            }
        },

        async created() {
            await this.fetch();
        },

        methods: {
            async fetch() {
                this.entitiesOrder = this.entity.list || [];

                const { data: restaurants } = await Vue.axios.get('/restaurants');
                this.business.restaurants = this.entity.id ? this.orderServices(restaurants) : restaurants;
                const { data: grocers } = await Vue.axios.get('/grocers');
                this.business.grocers = grocers;
                const { data: pharmacies } = await Vue.axios.get('/pharmacies');
                this.business.pharmacies = pharmacies;

                const { data: entityTypes } = await Vue.axios.get('/entities-type');
                await Promise.all(entityTypes.map(async type => {
                    const entities = await Vue.axios.get(`/entities/${type.code}`);
                    this.$set(this.business, type.code, entities?.data?.length ? entities.data : []);
                    this.routeNames.push({
                        label: type.title,
                        value: `entity-list-${type.code}`,
                        listVar: type.code,
                    })
                }));

                this.routeName = this.entity.id ? this.entity.route_name : 'restaurant-list';
                await this.setModel();
            },
            orderServices(services) {
                if (services?.length) {
                    const servicesCopy = [...services];
                    if(this.entitiesOrder) {
                        this.entitiesOrder.forEach((order, ind) => {
                            const index = servicesCopy.findIndex(el => el.id === order);
                            if (index !== -1) {
                                const [service] = servicesCopy.splice(index, 1);
                                servicesCopy.splice(ind, 0, service);
                            }
                        });
                    }
                    return servicesCopy;
                }
                return [];
            },
            updateRouteName(e) {
                this.model.route_name = e.target.value;
                this.routeName = this.model.route_name;
                this.list = [];
            },
            updateCode(code) {
                this.model.code = translit(code).toUpperCase().replace(/[-]/g, '_').substring(0, 20);
            },
            pictureUrl(picture) {
                return picture ? process.env.VUE_APP_STATIC_BASE_URL + '/' + picture : '';
            },

            async setModel() {
                this.model = morphism(this.schema, this.entity);
                this.model.route_name = this.model.route_name || this.routeNames[0].value;
                this.model.list = this.model.list || [];
                setTimeout(() => {
                    this.list = [];
                    for (var i = 0; i < this.entities.length; i++) {
                        this.list[this.entities[i].id] = this.model.list.includes(
                            this.entities[i].id
                        );
                    }
                }, 100);

                this.entitiesCopy = this.entities;
            },

            async submit() {
                const [error] = await to(this.$refs.validator.validate());

                if (error) {
                    return false;
                }

                this.model.enabled = this.model.enabled ? true : false;

                this.model.list = [];
                for (var i = 0; i < this.entitiesCopy.length; i++) {
                    if (this.list[this.entitiesCopy[i].id]) {
                        this.model.list.push(this.entitiesCopy[i].id);
                    }
                }

                if (typeof this.model.id === 'number') {
                    const [err] = await to(
                        this.axios.put(`/ads-places/${this.model.id}`, this.model)
                    );
                    if (err) {
                        this.$root.$emit('showError', 'Ошибка. Не удалось сохранить запись. ' + err);
                        return;
                    }
                } else {
                    const [err] = await to(this.axios.post('/ads-places', this.model));
                    if (err) {
                        this.$root.$emit('showError', 'Ошибка. Не удалось создать новую запись. ' + err);
                        return;
                    }
                }

                this.$emit('success');
            },

            promptDelete() {
                this.$refs.confirmDialog.open();
            },

            async confirmDelete() {
                if (!this.model.id) {
                    return false;
                }

                const [error] = await to(
                    this.axios.delete(`/ads-places/${this.model.id}`)
                );

                if (error) {
                    this.$root.$emit('showError', 'Ошибка удаления записи. ' + error);
                    return;
                }

                this.$emit('deleted');
            }
        },
    };
</script>
<style>
</style>
